import resourceConfig from '../config';

export default {
    resources: {
        [resourceConfig.name]: {
            name: 'FIAS |||| FIAS',
            fields: {
                id: 'ID',
                companyName: 'Company',
                productGroup: 'Product Group',
                items: 'Items',
                fiasId: 'Fias Id',
                kpp: 'Kpp'
            },
        },
    },
};